import {
  IGeneratedCallDetails,
  IGeneratedCallDetailsResponse,
} from 'src/app/interfaces/self-serve/responses/igenerated-call-details';

type CallDetailsMarkdownKey =
  | 'simulationDescription'
  | 'callDetailsOverviewScenario'
  | 'callDetailsOverviewGoal'
  | 'callDetailsAvatar';

// Order controls the section order in the rendered markdown.
const SECTION_LABELS: {
  key: CallDetailsMarkdownKey;
  label: string;
}[] = [
  { key: 'simulationDescription', label: 'Simulation description' },
  { key: 'callDetailsOverviewScenario', label: 'Scenario' },
  { key: 'callDetailsOverviewGoal', label: 'Goal' },
  { key: 'callDetailsAvatar', label: 'About the persona' },
];

// Shared with the content-refresh skeleton (generated-call-details.component)
// so its placeholder headings can never drift out of sync with these.
export const CALL_DETAILS_SECTION_LABELS = SECTION_LABELS.map((section) => section.label);

export function mapGeneratedCallDetailsResponse(
  response: IGeneratedCallDetailsResponse
): IGeneratedCallDetails {
  let contentMarkdown: string;

  if (response.callDetailsOverview) {
    const sections: string[] = [];
    if (response.simulationDescription?.trim()) {
      sections.push(`## Simulation description\n${response.simulationDescription.trim()}`);
    }
    sections.push(response.callDetailsOverview.trim());
    if (response.callDetailsAvatar?.trim()) {
      sections.push(`## About the persona\n<span class="avatar-body">${response.callDetailsAvatar.trim()}</span>`);
    }
    contentMarkdown = sections.join('\n\n');
  } else {
    contentMarkdown = SECTION_LABELS.map(({ key, label }) => [label, response[key]])
      .filter((section): section is [string, string] => !!section[1]?.trim())
      .map(([label, text]) => `## ${label}\n${text}`)
      .join('\n\n');
  }

  return {
    title: response.callName,
    contentMarkdown,
    avatarName: response.avatarName,
    avatarGender: response.avatarGender ?? null,
    welcomeMessage: response.welcomeMessage,
    resumeMessage: response.resumeMessage,
    simulationDescription: response.simulationDescription,
    callDetailsOverview: response.callDetailsOverview,
    callDetailsAvatar: response.callDetailsAvatar,
    callDetailsScoring: response.callDetailsScoring,
    callDetailsOverviewScenario: response.callDetailsOverviewScenario,
    callDetailsOverviewGoal: response.callDetailsOverviewGoal,
    skillUuid: response.skillUuid,
    methodologyUuid: response.methodologyUuid,
    generationUuid: response.generationUuid,
  };
}
